var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer bg-white py-4",attrs:{"id":"kt_footer"}},[_c('div',{staticClass:"text-dark text-center"},[_c('span',{staticClass:"text-muted font-weight-bold mr-2"},[_vm._v(" 2020 © My Realty Cloud's Real Estate Management System ")])])])
}]

export { render, staticRenderFns }